import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { stockMovementsPageDef } from '@/components/scm/scm-page-defs';

export default function ScmStockMovementsPage() {
  return <ScmPageRenderer pageDef={stockMovementsPageDef} />;
}
